export default {
  SUPPLIERS: (state) => {
    return state.suppliers
  }
}
